import { type FC } from 'react';
import { type IconBaseProps, IconMarket, IconOzon, IconWb } from '@direct-frontend/components';
import { type OpenApiSchemaPriceIndexMarketplace } from '../../api/schema';
import { OZON_SERVICE_NAME } from '../brand';

export const MARKETPLACES_ICON_LABEL_MAP: Record<
    OpenApiSchemaPriceIndexMarketplace,
    {
        Icon: FC<IconBaseProps>;
        title: string;
    }
> = {
    wildberries: {
        Icon: IconWb,
        title: 'Wildberries',
    },
    yandex_market: {
        Icon: IconMarket,
        title: 'Яндекс Маркет',
    },
    ozon: {
        Icon: IconOzon,
        title: OZON_SERVICE_NAME,
    },
};
